import { ReactElement } from 'react';
import SectionHeader from '../../components/SectionHeader';
import Button from '../../components/Button';
import { HiOutlineArrowRightOnRectangle } from 'react-icons/hi2';
import { useUser } from 'hooks/useUser';

export default function AccountView(): ReactElement {
  const [userProfile, signOut] = useUser();

  return (
    <>
      <SectionHeader title="Account" />
      <div className="cr-flex cr-flex-col cr-rounded-lg cr-bg-white cr-p-2 cr-text-center cr-shadow-md md:cr-w-[640px] md:cr-text-left">
        <div className="cr-p-3">
          <div className="cr-space-y-4">
            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">User Name</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.user_name || 'Not provided'}
              </div>
            </div>

            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">Email</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.email_address || 'Not provided'}
              </div>
            </div>

            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">Team</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.team?.name || 'Not provided'}
              </div>
            </div>
          </div>

          <div className="cr-mt-6">
            <Button
              onClick={() => signOut()}
              icon={<HiOutlineArrowRightOnRectangle className={'cr-size-7'} />}
              className="cr-border-red-600 cr-bg-red-600 cr-text-black hover:cr-bg-red-700"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
